import { render, staticRenderFns } from "./CrossingDisciplines.vue?vue&type=template&id=59c898b7&"
import script from "./CrossingDisciplines.vue?vue&type=script&lang=ts&"
export * from "./CrossingDisciplines.vue?vue&type=script&lang=ts&"
import style0 from "./CrossingDisciplines.vue?vue&type=style&index=0&id=59c898b7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports